import { Typography } from '@mui/material'
import ModalDialog from '../modal-dialog/ModalDialog'

export const LEAVE_TITLE = 'יש פרטים שלא נשמרו'

export const LEAVE_SAVE_LABEL = 'שמירה והמשך'

export const LEAVE_DISCARD_LABEL = 'המשך בלי לשמור'

export const LEAVE_CANCEL_LABEL = 'חזרה'

export default function PendingDetailsDialog({
    open,
    onSave,
    onDiscard,
    onCancel,
}) {
    const commands = [
        {
            label: LEAVE_CANCEL_LABEL,
            testId: 'leave-cancel',
            color: 'secondary',
            onClick: onCancel,
        },
        {
            label: LEAVE_DISCARD_LABEL,
            testId: 'leave-discard',
            color: 'secondary',
            onClick: onDiscard,
        },
        {
            label: LEAVE_SAVE_LABEL,
            testId: 'leave-save',
            color: 'primary',
            onClick: onSave,
        },
    ]

    return (
        <ModalDialog
            open={open}
            title={LEAVE_TITLE}
            commands={commands}
            onClose={onCancel}
        >
            <Typography variant="body2" data-testid="leave-dialog">לשמור את הפרטים לפני שממשיכים?</Typography>
        </ModalDialog>
    )
}
